import { render, staticRenderFns } from "./Unregister.vue?vue&type=template&id=572c0e04&"
import script from "./Unregister.vue?vue&type=script&lang=js&"
export * from "./Unregister.vue?vue&type=script&lang=js&"
import style0 from "./Unregister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports